// extracted by mini-css-extract-plugin
module.exports = {"contents":"mk","sectionHeading":"nk"};